
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Paper } from "@/data/productCategory/product/paper/paper";

import * as def from "@/definitions";
import { UuidHelper } from "@/helper/uuidHelper";
import { CompatibleHelper } from "@/helper/compatibleHelper";
import { ImageHelper } from "@/helper/imageHelper";
import { DebugHelper } from "@/helper/debugHelper";

@Component({
  components: {}
})
export default class PaperPreview extends Vue {
    // viewBox短辺の長さ
    static readonly VIEWBOX_MIN_LENGTH = 400;

    @Prop() private paper!: Paper;
    @Watch('paper')
    onPaperChanged(val: number, oldVal: number)
    {
        this.updateFrameInfoStyle();
    }

    @Prop() private isSelected!: boolean;

    @Prop() private paperRotation! : number;
    @Watch('paperRotation')
    onPaperRotationChanged(val: number, oldVal: number)
    {
        this.updateFrameInfoStyle();
    }

    frameInfoStyle = {
        width: "",
        height: "",
        position: "absolute",
        top: "0px"
    };

    mounted() 
    {
        this.updateFrameInfoStyle();
    }

    updateFrameInfoStyle()
    {
        this.$nextTick(() => 
        {
            let papersvg = this.$refs.papersvg as SVGElement;
            let parentNode : any;
            if(papersvg.parentNode){
                parentNode = papersvg.parentNode
            }
            let width = papersvg.clientWidth || parentNode.clientWidth
            let height = papersvg.clientHeight || parentNode.clientHeight
            this.frameInfoStyle.width = width - 6 + "px";
            this.frameInfoStyle.height = height - 6 + "px";
        });
    }

    // mm -> svg
    private get scale() 
    {
        if (Math.min(this.paper.width, this.paper.height) == 0) 
        {
            return 0;
        }
        return (PaperPreview.VIEWBOX_MIN_LENGTH / Math.min(this.paper.width, this.paper.height));
    }

    // viewBox幅
    private get viewWidth(): number 
    {
        return this.pageWidth;
    }

    // viewBox高さ
    private get viewHeight(): number 
    {
        return this.pageHeight;
    }

    // viewBox
    private get viewBox(): string 
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    private get pageWidth() 
    {
        var paperWidth = this.paperRotation == 90 || this.paperRotation == 270 ? this.paper.height : this.paper.width;
        return paperWidth * this.scale;
    }

    private get pageHeight() 
    {
        var paperHeight = this.paperRotation == 90 || this.paperRotation == 270 ? this.paper.width : this.paper.height;
        return paperHeight * this.scale;
    }

    private get pageBackgroundColor() 
    {
        return "#FFFFFF";
    }

    private get frameItems() 
    {
        var items = new Array();

        if(this.paperRotation == 90)
        {
            for (var i = 0; i < this.paper.frameInfoList.length; ++i) 
            {
                var frameInfo = this.paper.frameInfoList[i];
                var x = this.paper.height - frameInfo.topMargin;
                for (var r = 0; r < frameInfo.row; ++r) 
                {
                    var y = frameInfo.leftMargin;
                    for (var c = 0; c < frameInfo.col; ++c) 
                    {
                        items.push({
                            x: x - frameInfo.height,
                            y: y,
                            width: frameInfo.height,
                            height: frameInfo.width,
                            type: frameInfo.shapeInfo.name,
                            diameter: frameInfo.shapeInfo.innerDiameter,
                            key: UuidHelper.getUuid()
                        });
                        y += frameInfo.width + frameInfo.horizontalPadding;
                    }
                    x -= frameInfo.height + frameInfo.verticalPadding;
                }
            }
        }
        else if(this.paperRotation == 180)
        {
            for (var i = 0; i < this.paper.frameInfoList.length; ++i) 
            {
                var frameInfo = this.paper.frameInfoList[i];
                var y = this.paper.height - frameInfo.topMargin;
                for (var r = 0; r < frameInfo.row; ++r) 
                {
                    var x = this.paper.width - frameInfo.leftMargin;
                    for (var c = 0; c < frameInfo.col; ++c) 
                    {
                        items.push({
                            x: x - frameInfo.width,
                            y: y - frameInfo.height,
                            width: frameInfo.width,
                            height: frameInfo.height,
                            type: frameInfo.shapeInfo.name,
                            diameter: frameInfo.shapeInfo.innerDiameter,
                            key: UuidHelper.getUuid()
                        });
                        x -= frameInfo.width + frameInfo.horizontalPadding;
                    }
                    y -= frameInfo.height + frameInfo.verticalPadding;
                }
            }
        }
        else if(this.paperRotation == 270)
        {
            for (var i = 0; i < this.paper.frameInfoList.length; ++i) 
            {
                var frameInfo = this.paper.frameInfoList[i];
                var x = frameInfo.topMargin;
                for (var r = 0; r < frameInfo.row; ++r) 
                {
                    var y = this.paper.width - frameInfo.leftMargin;
                    for (var c = 0; c < frameInfo.col; ++c) 
                    {
                        items.push({
                            x: x,
                            y: y - frameInfo.width,
                            width: frameInfo.height,
                            height: frameInfo.width,
                            type: frameInfo.shapeInfo.name,
                            diameter: frameInfo.shapeInfo.innerDiameter,
                            key: UuidHelper.getUuid()
                        });
                        y -= frameInfo.width + frameInfo.horizontalPadding;
                    }
                    x += frameInfo.height + frameInfo.verticalPadding;
                }
            }
        }
        else
        {
            for (var i = 0; i < this.paper.frameInfoList.length; ++i) 
            {
                var frameInfo = this.paper.frameInfoList[i];
                var y = frameInfo.topMargin;
                for (var r = 0; r < frameInfo.row; ++r) 
                {
                    var x = frameInfo.leftMargin;
                    for (var c = 0; c < frameInfo.col; ++c) 
                    {
                        items.push({
                            x: x,
                            y: y,
                            width: frameInfo.width,
                            height: frameInfo.height,
                            type: frameInfo.shapeInfo.name,
                            diameter: frameInfo.shapeInfo.innerDiameter,
                            key: UuidHelper.getUuid()
                        });
                        x += frameInfo.width + frameInfo.horizontalPadding;
                    }
                    y += frameInfo.height + frameInfo.verticalPadding;
                }
            }
        }

        return items;
    }

    private getRectX(item) {
        return item.x * this.scale;
    }

    private getRectY(item) {
        return item.y * this.scale;
    }

    private getRectWidth(item) {
        return item.width * this.scale;
    }

    private getRectHeight(item) 
    {
        return item.height * this.scale;
    }

    private getRectRadius(item) 
    {
        if (item.type == "rect") { return 0; }
        return item.diameter * this.scale;
    }

    private getCircleCX(item) 
    {
        return (item.x + item.width / 2) * this.scale;
    }

    private getCircleCY(item) 
    {
        return (item.y + item.height / 2) * this.scale;
    }

    private getCircleR(item) 
    {
        return (Math.min(item.width, item.height) / 2) * this.scale;
    }

    private getEllipseRX(item)
    {
        return item.width / 2 * this.scale;
    }

    private getEllipseRY(item)
    {
        return item.height / 2 * this.scale;
    }

    private getInnerR(item) 
    {
        return (item.diameter / 2) * this.scale;
    }

    private get isFrameImageVisible() 
    {
        if (this.paper.frameInfoList.length == 0) 
        {
            return false;
        }
        var shapeInfo = this.paper.frameInfoList[0].shapeInfo;
        return shapeInfo.useFrontFxg == "1" || shapeInfo.useFrontFxg == 1;
    }

    private get frameImageSource() 
    {
        if (this.paper.frameInfoList.length == 0) 
        {
            return "";
        }
        var shapeInfo = this.paper.frameInfoList[0].shapeInfo;
        if (shapeInfo.frontFxg == "") 
        {
            return "";
        }
        var tag = CompatibleHelper.convertCompressedEncodedImageToSvg(shapeInfo.frontFxg);
        if (tag == null) { return ""; }
        var tagfix = CompatibleHelper.removeBacklayerFromSvg(tag);
        var image = ImageHelper.convertSVGTagToBase64(tagfix);
        return image;
    }

    private get frameImageWidth()
    {
        return this.paperRotation == 90 || this.paperRotation == 270 ? this.pageHeight : this.pageWidth;
    }

    private get frameImageHeight()
    {
        return this.paperRotation == 90 || this.paperRotation == 270 ? this.pageWidth : this.pageHeight;
    }

    private get frameImageTransform()
    {
        var transform = "";

        if(this.paperRotation == 90 || this.paperRotation == 270)
        {
            transform += "translate(" + this.frameImageHeight / 2 + " " + this.frameImageWidth / 2 + "),";
        }
        else
        {
            transform += "translate(" + this.frameImageWidth / 2 + " " + this.frameImageHeight / 2 + "),";
        }

        // 回転を適用する
        transform += "rotate(" + this.paperRotation + "),";

        transform += "translate(" + -this.frameImageWidth / 2 + " " + -this.frameImageHeight / 2 + ")";

        return transform;
    }

    selectPaper() 
    {
        //   DebugHelper.trace(this.paper)

        //   if(this.paper.id != this.selectedPaper.id){
        this.$emit("selectPaper", this.paper.id);
        //   }
    }

    private get userConfigColorStyle(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
}
